import { useQuery } from '@tanstack/react-query';
import { apiService } from '../services/api';

/** Backend Features:EnableDevFakePayments — Param bypass test butonları için */
export function useDevFakePaymentEnabled() {
  return useQuery({
    queryKey: ['dev-fake-payment-enabled'],
    queryFn: async () => {
      const res = await apiService.getDevFakePaymentEnabled();
      if (!res.success || !res.data) return false;
      return res.data.enabled === true;
    },
    staleTime: 60_000,
    retry: false,
  });
}
